// import React, { useEffect } from "react";
// import {
//     Paper,
//     Typography,
//     Button,
//     Stack,
//     TextField,
//     IconButton,
//     Grid
// } from "@mui/material";
// import { Delete } from "@mui/icons-material";
// import { toast } from "react-toastify";

// const AttributeTabContent = ({
//     productData,
//     setProductData,
//     onBack,
//     onNext
// }) => {

//     // ================= INIT =================
//     useEffect(() => {
//         if (!productData.attributes) {
//             setProductData(prev => ({
//                 ...prev,
//                 attributes: [{ id: null, name: "", value: "" }]
//             }));
//         }
//     }, []);

//     // ================= HANDLE CHANGE =================
//     const handleChange = (index, field, value) => {

//         const updated = [...productData.attributes];
//         updated[index][field] = value;

//         // Remove completely empty rows except last
//         const cleaned = updated.filter((attr, i) => {
//             if (i === updated.length - 1) return true;
//             return attr.name !== "" || attr.value !== "";
//         });

//         // Auto add new row if last row filled
//         const lastRow = cleaned[cleaned.length - 1];

//         if (lastRow.name !== "" && lastRow.value !== "") {
//             cleaned.push({ id: null, name: "", value: "" });
//         }

//         setProductData(prev => ({
//             ...prev,
//             attributes: cleaned
//         }));
//     };

//     // ================= DELETE =================
//     const handleDelete = (index) => {

//         const updated = productData.attributes.filter((_, i) => i !== index);

//         if (updated.length === 0) {
//             updated.push({ id: null, name: "", value: "" });
//         }

//         setProductData(prev => ({
//             ...prev,
//             attributes: updated
//         }));
//     };

//     // ================= SAVE =================
//     const handleNext = () => {

//         if (!productData.attributes || productData.attributes.length === 0) {
//             toast.error("Please add at least one attribute");
//             return;
//         }

//         const filtered = productData.attributes.filter(
//             attr => attr.name.trim() !== "" && attr.value.trim() !== ""
//         );

//         setProductData(prev => ({
//             ...prev,
//             attributes: filtered
//         }));

//         onNext();
//     };

//     return (
//         <Paper
//             sx={{
//                 p: 5,
//                 borderRadius: 3,
//                 minHeight: 300
//             }}
//         >
//             <Grid container spacing={2}>
//                 {productData.attributes?.map((attr, index) => (
//                     <React.Fragment key={index}>
//                         <Grid item xs={12} md={5}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Attribute Name"
//                                 value={attr.name}
//                                 onChange={(e) =>
//                                     handleChange(index, "name", e.target.value)
//                                 }
//                             />
//                         </Grid>

//                         <Grid item xs={12} md={5}>
//                             <TextField
//                                 fullWidth
//                                 size="small"
//                                 label="Attribute Value"
//                                 value={attr.value}
//                                 onChange={(e) =>
//                                     handleChange(index, "value", e.target.value)
//                                 }
//                             />
//                         </Grid>

//                         <Grid
//                             item
//                             xs={12}
//                             md={2}
//                             display="flex"
//                             alignItems="center"
//                         >
//                             {productData.attributes.length > 1 && (
//                                 <IconButton
//                                     color="error"
//                                     onClick={() => handleDelete(index)}
//                                 >
//                                     <Delete />
//                                 </IconButton>
//                             )}
//                         </Grid>
//                     </React.Fragment>
//                 ))}
//             </Grid>

//             {/* Bottom Buttons */}
//             <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={2}
//                 justifyContent="flex-end"
//                 mt={5}
//             >
//                 <Button
//                     variant="outlined"
//                     onClick={onBack}
//                     sx={{ borderRadius: 2, textTransform: "none" }}
//                 >
//                     Back
//                 </Button>

//                 <Button
//                     variant="contained"
//                     onClick={handleNext}
//                     sx={{ borderRadius: 2, textTransform: "none" }}
//                 >
//                     Save & Continue
//                 </Button>
//             </Stack>
//         </Paper>
//     );
// };

// export default AttributeTabContent;

import React, { useEffect } from "react";
import {
    Paper,
    Button,
    Stack,
    TextField,
    IconButton,
    Grid
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import { toast } from "react-toastify";

const AttributeTabContent = ({
    productData,
    setProductData,
    onBack,
    onNext
}) => {

    // ================= INIT =================
    useEffect(() => {

        // Agar create mode hai aur attributes empty hai
        if (!productData.attributes || productData.attributes.length === 0) {
            setProductData(prev => ({
                ...prev,
                attributes: [{ id: null, name: "", value: "" }]
            }));
        }

    }, []);

    // ================= HANDLE CHANGE =================
    const handleChange = (index, field, value) => {

        const updated = [...productData.attributes];
        updated[index][field] = value;

        setProductData(prev => ({
            ...prev,
            attributes: updated
        }));
    };

    // ================= ADD NEW ROW =================
    const handleAddRow = () => {

        const lastRow = productData.attributes[productData.attributes.length - 1];

        // Agar last row empty hai to new row add mat karo
        if (!lastRow.name || !lastRow.value) {
            toast.error("Please fill current attribute first");
            return;
        }

        setProductData(prev => ({
            ...prev,
            attributes: [
                ...prev.attributes,
                { id: null, name: "", value: "" }
            ]
        }));
    };

    // ================= DELETE =================
    const handleDelete = (index) => {

        const updated = productData.attributes.filter((_, i) => i !== index);

        if (updated.length === 0) {
            updated.push({ id: null, name: "", value: "" });
        }

        setProductData(prev => ({
            ...prev,
            attributes: updated
        }));
    };

    // ================= SAVE =================
    const handleNext = () => {

        const attributes = productData.attributes;

        // Remove completely empty rows
        const filtered = attributes.filter(
            attr => attr.name.trim() !== "" || attr.value.trim() !== ""
        );

        // Check half-filled rows
        for (let attr of filtered) {
            if (!attr.name.trim() || !attr.value.trim()) {
                toast.error("Please fill both name and value for all attributes");
                return;
            }
        }

        if (filtered.length === 0) {
            toast.error("Please add at least one attribute");
            return;
        }

        // Final clean payload
        const finalPayload = filtered.map(attr => ({
            id: attr.id || null,   // 🔥 id preserved for edit
            name: attr.name.trim(),
            value: attr.value.trim()
        }));

        setProductData(prev => ({
            ...prev,
            attributes: finalPayload
        }));

        onNext();
    };

    return (
        <Paper
            sx={{
                p: 5,
                borderRadius: 3,
                minHeight: 300
            }}
        >
            <Grid container spacing={2}>
                {productData.attributes?.map((attr, index) => (
                    <React.Fragment key={attr.id || index}>
                        <Grid item xs={12} md={5}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Attribute Name"
                                value={attr.name}
                                onChange={(e) =>
                                    handleChange(index, "name", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={5}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Attribute Value"
                                value={attr.value}
                                onChange={(e) =>
                                    handleChange(index, "value", e.target.value)
                                }
                            />
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            md={2}
                            display="flex"
                            alignItems="center"
                        >
                            {productData.attributes.length > 1 && (
                                <IconButton
                                    color="error"
                                    onClick={() => handleDelete(index)}
                                >
                                    <Delete />
                                </IconButton>
                            )}
                        </Grid>
                    </React.Fragment>
                ))}
            </Grid>

            {/* Add Button */}
            <Stack mt={3}>
                <Button
                    variant="outlined"
                    onClick={handleAddRow}
                    sx={{ alignSelf: "flex-start" }}
                >
                    + Add Attribute
                </Button>
            </Stack>

            {/* Bottom Buttons */}
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="flex-end"
                mt={5}
            >
                <Button
                    variant="outlined"
                    onClick={onBack}
                    sx={{ borderRadius: 2, textTransform: "none" }}
                >
                    Back
                </Button>

                <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ borderRadius: 2, textTransform: "none" }}
                >
                    Save & Continue
                </Button>
            </Stack>
        </Paper>
    );
};

export default AttributeTabContent;